import * as api from '../api';
import { BaseModel } from '../common';

export class App {

    private static _features : string[];
    private static _maintenance : boolean; 
    private static _maintenanceMessage : string;

    public static get features() {
        return this._features;
    }

    public static get maintenance() {
        return this._maintenance;
    }

    public static get maintenanceMessage() {
        return this._maintenanceMessage;
    }

    private static adaptStatus(status : api.ApiAppConfig) {
        this._features = status.features;
        this._maintenance = status.maintenance;
        this._maintenanceMessage = status.blocker_message;
    }

    static status(): Promise<api.ApiAppConfig> {
        return BaseModel
            .inject(api.AppApi)
            .getStatus('1.0', 'web')
            .toPromise()
            .then(status => {
                this.adaptStatus(status);
                return status;
            })
            .catch(e => {
                throw e.json();
            })
        ;
    }
}